import React from 'react';
import { Loader2 } from 'lucide-react';

export default function LoadingSpinner({ size = 'default', text, className = '' }) {
  const sizePx = {
    sm: '20px',
    default: '40px',
    lg: '60px'
  };

  const borderSize = {
    sm: '2px',
    default: '3px',
    lg: '4px'
  };

  return (
    <div className={`flex flex-col items-center justify-center py-12 ${className}`}>
      <div style={{
        width: sizePx[size] || sizePx.default,
        height: sizePx[size] || sizePx.default,
        border: `${borderSize[size] || borderSize.default} solid #f3f3f3`,
        borderTop: `${borderSize[size] || borderSize.default} solid #16A34A`,
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite'
      }}></div>
      {text && <p className="mt-4 text-gray-500 font-medium">{text}</p>}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
